(() => {
  for (const shop of document.querySelectorAll('[data-athena-shop]')) {
    if (shop.dataset.bound) continue;
    shop.dataset.bound = 'true';
    const tabs = [...shop.querySelectorAll('[data-shop-tab]')];
    function selectTab(tab, focus = false) {
      for (const button of tabs) {
        const active = button === tab;
        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
      }
      for (const panel of shop.querySelectorAll('[data-shop-panel]')) panel.hidden = panel.dataset.shopPanel !== tab.dataset.shopTab;
      shop.dataset.activeShopTab = tab.dataset.shopTab;
      if (focus) tab.focus();
    }
    for (const [index, tab] of tabs.entries()) {
      tab.addEventListener('click', () => selectTab(tab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); selectTab(tabs[next], true); }
      });
    }
    const contactToggle = shop.querySelector('[data-booth-contact-open]');
    const contactWrap = shop.querySelector('[data-booth-contact-wrap]');
    if (contactToggle && contactWrap) {
      const openContact = (focus = false) => {
        contactWrap.hidden = false;
        contactToggle.setAttribute('aria-expanded', 'true');
        if (focus) contactWrap.querySelector('input:not([type="hidden"])')?.focus();
      };
      contactToggle.addEventListener('click', () => {
        if (contactWrap.hidden) openContact(true);
        else { contactWrap.hidden = true; contactToggle.setAttribute('aria-expanded', 'false'); }
      });
      if (contactWrap.querySelector('[data-booth-result]')) {
        const boothTab = tabs.find(tab => tab.dataset.shopTab === 'booth');
        if (boothTab) selectTab(boothTab);
        openContact();
      }
    }
    // Start overflowing ticket rows with the early/friendship plans in view.
    // Only reposition after a width change, so swiping stays where the user leaves it.
    const rowWidths = new WeakMap();
    const ticketRowObserver = new ResizeObserver(entries => {
      for (const { target: row } of entries) {
        const width = row.clientWidth;
        if (!width || rowWidths.get(row) === width) continue;
        rowWidths.set(row, width);
        row.scrollLeft = Math.max(0, row.scrollWidth - width);
      }
    });
    for (const row of shop.querySelectorAll('.athena-purchase__group-options')) ticketRowObserver.observe(row);
  }
  const yen = value => new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(value);
  for (const root of document.querySelectorAll('[data-athena-purchase]')) {
    if (root.dataset.multi === 'true') continue;
    if (root.dataset.bound) continue;
    root.dataset.bound = 'true';
    const find = selector => root.querySelector(selector);
    const catalog = JSON.parse(find('[data-ticket-catalog]').textContent);
    const form = find('[data-ticket-purchase-form]');
    const checkout = find('[data-checkout]');
    const dialog = find('[data-checkout-dialog]');
    const details = find('[data-checkout-details]');
    const payment = find('[data-payment]');
    const back = find('[data-dialog-back]');
    const discord = details.elements.discord;
    const discordSkip = find('[data-discord-skip]');
    const discordJoined = details.elements.discordJoined;
    const requiresGameDiscord = variant => ['50966020718849','50966020751617'].includes(variant?.id);
    let discordSkipped = false;
    let requestKey, checkoutQuote, pendingAttempt, offerRequest=0;
    let early = {status:'upcoming',prices:{}}, availability={}, busy=false, quoting=false, offersLoaded=false;
    const statusLabels={loading:'',available:'',upcoming:'受付開始前',sold_out:'SOLD OUT',reserved:'手続き中',ended:'受付終了'};
    function priceFor(variant,mode,offer='regular') {
      return offer==='early'?early.prices[`${variant.id}:solo`]:mode==='together'?variant.invitationPrice:variant.price;
    }
    function selection() {
      const [variantId,mode,offer] = (form.elements['athena-ticket-kind'].value || '').split(':');
      return {variant:catalog.find(item=>item.id===variantId),mode,offer};
    }
    function quoteFor({variant,mode,offer}) {
      const regularTotal=priceFor(variant,mode,offer);
      const earlyTotal=early.prices[`${variant.id}:solo`];
      const automatic=offer==='regular'&&mode==='solo'&&early.status==='available'&&Number.isInteger(earlyTotal)&&earlyTotal>0&&earlyTotal<regularTotal;
      return {variantId:variant.id,mode,requestedOffer:offer,offer:automatic?'early':offer,total:automatic?earlyTotal:regularTotal,automatic};
    }
    function currentQuote(variant,mode,offer) {
      if(!checkoutQuote||!variant)return undefined;
      return checkoutQuote.variantId===variant.id&&checkoutQuote.mode===mode&&checkoutQuote.requestedOffer===offer?checkoutQuote:undefined;
    }
    function pendingFor(variantId,mode,offer) {
      const quote=pendingAttempt?.quote;
      return quote&&quote.variantId===variantId&&quote.mode===mode&&quote.requestedOffer===offer?pendingAttempt:undefined;
    }
    function optionStatus(variantId,offer) {
      const status=availability[variantId]?.status||'upcoming';
      if(status==='sold_out'||status==='reserved')return status;
      if(offer==='early'&&early.status!=='available')return early.status;
      return offersLoaded?status:'loading';
    }
    function selectable(variantId,offer) {
      const status=optionStatus(variantId,offer);
      if(['sold_out','reserved','ended','loading'].includes(status))return false;
      if(offer==='early'&&early.status!=='available')return false;
      return status==='available'||(status==='upcoming'&&root.dataset.sellable!=='true');
    }
    function render(resetRequest=true) {
      if(resetRequest){requestKey=undefined;checkoutQuote=undefined;pendingAttempt=undefined;}
      let expiredSelection=false;
      for(const amount of root.querySelectorAll('[data-option-price]')) {
        const [id,mode,offer]=amount.dataset.optionPrice.split(':');
        const item=catalog.find(v=>v.id===id),value=priceFor(item,mode,offer);
        const label=amount.closest('label'),input=label.querySelector('input');
        if(Number.isFinite(value))amount.textContent=yen(value);
        const before=label.querySelector('[data-before-price]');
        before.hidden=offer!=='early'||(Number.isFinite(value)&&value>=item.price);
        before.textContent=yen(item.price);
        const saving=label.querySelector('[data-friendship-saving]');
        if(saving) {
          const difference=item.price*2-item.invitationPrice;
          saving.hidden=!Number.isFinite(difference)||difference<=0;
          saving.textContent=`${new Intl.NumberFormat('ja-JP').format(difference)}円お得`;
          saving.title='通常の1名分チケットを2枚買う場合との比較';
        }
        const earlySaving=label.querySelector('[data-early-saving]');
        if(earlySaving) {
          const difference=item.price-value;
          const valid=offer==='early'&&Number.isFinite(item.price)&&Number.isFinite(value)&&value>0&&Number.isFinite(difference)&&difference>0;
          earlySaving.hidden=!valid;
          earlySaving.textContent=valid?`${new Intl.NumberFormat('ja-JP').format(difference)}円お得`:'';
          earlySaving.title='通常の1名分チケットとの比較';
        }
        const state=optionStatus(id,offer),canSelect=selectable(id,offer)||!!pendingFor(id,mode,offer);
        label.dataset.state=state;
        const limited=label.querySelector('[data-early-now]');
        if(limited)limited.hidden=early.status!=='available'||['sold_out','reserved','ended','loading'].includes(state);
        const stateLabel=label.querySelector('[data-option-state]');
        stateLabel.textContent=statusLabels[state]||'';
        stateLabel.hidden=!stateLabel.textContent||(state==='upcoming'&&root.dataset.sellable!=='true');
        if(!canSelect&&input.checked){input.checked=false;expiredSelection=true;requestKey=undefined;checkoutQuote=undefined;}
        input.disabled=busy||quoting||!canSelect;
      }
      const {variant,mode,offer}=selection(),invited=mode==='together';
      const quote=currentQuote(variant,mode,offer);
      const price=variant?(quote?.total??priceFor(variant,mode,offer)):undefined;
      const [name,detail]=variant?variant.name.split('（'):[];
      root.classList.toggle('athena-purchase--unselected',!variant);
      find('[data-selected-kind]').textContent=name||'チケットを選択';
      find('[data-selected-detail]').textContent=detail?`（${detail}`:'';
      find('[data-selected-detail]').hidden=!detail;
      find('[data-selected-offer]').hidden=!invited;
      find('[data-selected-sale]').hidden=!variant||(quote?.offer??offer)!=='early';
      find('[data-selected-admissions]').textContent=variant?(invited?'2名分':'1名分'):'';
      find('[data-today-total]').textContent=Number.isFinite(price)?yen(price):'—';
      checkout.disabled=busy||quoting||root.dataset.sellable!=='true'||!root.dataset.service||!Number.isFinite(price)||!offersLoaded||!variant||(!selectable(variant.id,offer)&&!pendingFor(variant.id,mode,offer))||(invited&&!variant.pairEligible);
      find('[data-purchase-status]').textContent=expiredSelection?'選択したチケットは受付を終了しました。':'';
    }
    form.addEventListener('change',()=>render());
    async function loadOffers(background=false) {
      const sequence=++offerRequest;
      const response=await fetch(new URL('/api/offers',root.dataset.service),{credentials:'omit',cache:'no-store'});
      if(!response.ok)throw Error('チケットの受付状況を確認できませんでした。もう一度お試しください。');
      const data=await response.json();
      if(!data.early||!['upcoming','available','sold_out','reserved','ended'].includes(data.early.status)||!data.tickets)throw Error('チケットの受付状況を確認できませんでした。');
      if(sequence!==offerRequest||(background&&(busy||quoting||dialog.open)))return false;
      early=data.early;availability=data.tickets;offersLoaded=true;
      return true;
    }
    async function refreshOffers() {
      if(!root.dataset.service||busy||quoting||dialog.open||document.hidden)return;
      try {if(!await loadOffers(true)||busy||quoting||dialog.open)return;}catch{return;}
      render(false);
    }
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      if(checkout.disabled||root.dataset.sellable!=='true')return;
      quoting=true;render(false);
      find('[data-purchase-status]').textContent='チケットを確認しています…';
      try {
        const before=selection();
        if(!pendingFor(before.variant?.id,before.mode,before.offer))await loadOffers();
        quoting=false;render(false);
        const selected=selection();
        const pending=pendingFor(selected.variant?.id,selected.mode,selected.offer);
        if(!selected.variant||(!pending&&!selectable(selected.variant.id,selected.offer)))return;
        const quote=pending?.quote||quoteFor(selected);
        if(!Number.isSafeInteger(quote.total)||quote.total<1)throw Error('チケットの料金を確認できませんでした。もう一度お試しください。');
        if(pending)requestKey=pending.requestKey;
        else if(checkoutQuote&&(checkoutQuote.total!==quote.total||checkoutQuote.offer!==quote.offer))requestKey=undefined;
        checkoutQuote=quote;render(false);
        const plan=quote.offer==='early'?'アーリーバード（早割）・1名分':quote.mode==='together'?'フレンドシップチケット・2名分':'通常・1名分';
        find('[data-dialog-selection]').textContent=`${selected.variant.name}・${plan} / ${yen(quote.total)}`;
        find('[data-dialog-discount]').hidden=!quote.automatic;
        const gameRequired=requiresGameDiscord(selected.variant);
        dialog.dataset.discordRequired=String(gameRequired);
        if(gameRequired&&discordSkipped){discordSkipped=false;requestKey=undefined;pendingAttempt=undefined;}
        discordSkip.hidden=gameRequired;discordSkip.setAttribute('aria-pressed',String(discordSkipped));
        discordSkip.textContent=discordSkipped?'Discord IDの入力に戻る':'どうしても入力できない場合';
        discord.required=!discordSkipped;discord.disabled=discordSkipped;
        find('[data-discord-requirement]').textContent=discordSkipped?'スキップ中':'必須';
        find('[data-discord-joined]').hidden=!gameRequired;discordJoined.required=gameRequired;discordJoined.disabled=!gameRequired;
        find('[data-discord-invite-message]').textContent=gameRequired?'Discordへの参加・ID入力は必須です':'Discordに参加してください';
        find('[data-dialog-status]').textContent='';dialog.showModal();if(discordSkipped)payment.focus();else discord.focus();
      }catch(error){
        quoting=false;render(false);find('[data-purchase-status]').textContent=error.message;
      }
    });
    back.addEventListener('click',()=>{if(!busy)dialog.close();});
    dialog.addEventListener('cancel',event=>{if(busy)event.preventDefault();});
    dialog.addEventListener('close',()=>{checkoutQuote=pendingAttempt?.quote;render(false);checkout.focus();refreshOffers();});
    discord.addEventListener('input',()=>{discord.setCustomValidity('');requestKey=undefined;pendingAttempt=undefined;});
    discordSkip.addEventListener('click',()=>{
      if(busy||requiresGameDiscord(selection().variant))return;
      discordSkipped=!discordSkipped;
      discord.required=!discordSkipped;discord.disabled=discordSkipped;discord.setCustomValidity('');
      discordSkip.setAttribute('aria-pressed',String(discordSkipped));
      discordSkip.textContent=discordSkipped?'Discord IDの入力に戻る':'どうしても入力できない場合';
      find('[data-discord-requirement]').textContent=discordSkipped?'スキップ中':'必須';
      requestKey=undefined;pendingAttempt=undefined;
      if(!discordSkipped)discord.focus();
    });
    details.addEventListener('submit',async event=>{
      event.preventDefault();
      if(busy||checkout.disabled||root.dataset.sellable!=='true'||!checkoutQuote)return;
      const discordValue=discordSkipped?'':discord.value.trim().replace(/^@/,'');
      const gameRequired=requiresGameDiscord(selection().variant);
      if(gameRequired&&(discordSkipped||!discordValue||!discordJoined.checked)){
        find('[data-dialog-status]').textContent='Discordへの参加とID入力を確認してください。';details.reportValidity();return;
      }
      discord.setCustomValidity(!discordSkipped&&(!discordValue||/[\s\u0000-\u001f\u007f]/u.test(discordValue))?'Discordのユーザー名を確認してください。':'');
      if(!details.reportValidity())return;
      busy=true;checkout.disabled=true;payment.disabled=back.disabled=discord.disabled=discordJoined.disabled=true;
      discordSkip.disabled=true;
      for(const input of form.querySelectorAll('input'))input.disabled=true;
      find('[data-dialog-status]').textContent='お支払い画面に進んでいます…';
      try {
        const retrying=!!pendingAttempt;
        requestKey ||= btoa(String.fromCharCode(...crypto.getRandomValues(new Uint8Array(32)))).replaceAll('+','-').replaceAll('/','_').replace(/=+$/,'');
        pendingAttempt ||= {quote:{...checkoutQuote},requestKey};
        const attempt=pendingAttempt;
        const response=await fetch(new URL('/api/checkout',root.dataset.service),{method:'POST',credentials:'omit',headers:{'Content-Type':'application/json'},body:JSON.stringify({variantId:attempt.quote.variantId,mode:attempt.quote.mode,offer:attempt.quote.requestedOffer,discord:discordValue,discordSkipped,...(gameRequired?{discordJoined:discordJoined.checked}:{}),requestKey:attempt.requestKey,expectedTotal:attempt.quote.total})});
        const data=await response.json();
        if(!response.ok){
          // A first-attempt 4xx did not create an invoice. After an ambiguous
          // failure, even 409 may refer to an existing draft: keep its identity.
          if(response.status>=400&&response.status<500&&!retrying){pendingAttempt=undefined;requestKey=undefined;}
          throw new Error(data.error||'購入手続きを開始できませんでした。');
        }
        const destination=new URL(data.checkoutUrl);
        if(destination.protocol!=='https:'||![location.hostname,root.dataset.shopDomain,'checkout.shopify.com'].includes(destination.hostname))throw new Error('購入先を確認できませんでした。');
        location.assign(destination.href);
      }catch(error){
        busy=false;payment.disabled=back.disabled=discordSkip.disabled=false;discord.disabled=discordSkipped;discordJoined.disabled=!gameRequired;render(false);
        find('[data-dialog-status]').textContent=error.message||'通信を確認して再度お試しください。';
      }
    });
    if(catalog.length)render();else{form.hidden=true;checkout.disabled=true;}
    refreshOffers();setInterval(refreshOffers,30000);document.addEventListener('visibilitychange',refreshOffers);
  }
})();
